import React, { useState } from "react";
import { Container, Grid } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { PageHeader } from "../../components/base";
import MyAccount from "./pages/MyAccount";
import UpdateUserData from "./pages/UpdateUserData";

const AccountContainer = () => {
  // Lo que devuelve el servidor al guardar: el perfil lo muestra sin pedir otra vez los datos.
  const [perfilActualizado, setPerfilActualizado] = useState(null);

  return (
    <Container maxWidth={false} disableGutters>
      <PageHeader titulo="Mi cuenta" icono={<FontAwesomeIcon icon={faUser} />} />

      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
          <MyAccount actualizacion={perfilActualizado} />
        </Grid>

        <Grid item xs={12} md={7}>
          <UpdateUserData onGuardado={setPerfilActualizado} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default AccountContainer;
